export const APP_VERSION = "1.2";
export const APP_VERSION_NOTE = `Version ${APP_VERSION}`;
